<template>
    <div class="w-100 h-100 position-absolute pre-loader d-flex justify-content-center align-items-center">
        <b-spinner class="mr-2" type="border" variant="dark" small></b-spinner>
    </div>
</template>

<script>
export default {
  name: 'Preloader'
}
</script>

<style scoped>
    .pre-loader {
        background-color: rgb(255, 255, 255, 0.4);
        z-index: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue